import { Navbar } from "@/components/sections/Navbar";
import { Hero } from "@/components/sections/Hero";
import { TrustStrip } from "@/components/sections/TrustStrip";
import { WhyTiming } from "@/components/sections/WhyTiming";
import { WhyChoose } from "@/components/sections/WhyChoose";
import { WhoFor } from "@/components/sections/WhoFor";
import { SampleReport } from "@/components/sections/SampleReport";
import { HowItWorks } from "@/components/sections/HowItWorks";
import { WhatPowers } from "@/components/sections/WhatPowers";
import { WhatsIncluded } from "@/components/sections/WhatsIncluded";
import { Pricing } from "@/components/sections/Pricing";
import { Testimonials } from "@/components/sections/Testimonials";
import { FAQ } from "@/components/sections/FAQ";
import { FinalCTA } from "@/components/sections/FinalCTA";
import { Footer } from "@/components/sections/Footer";
import { FloatingCTA } from "@/components/shared/FloatingCTA";

export default function Home() {
  return (
    <div className="min-h-screen bg-cream">
      <Navbar />
      <main>
        <Hero />
        <TrustStrip />
        <WhyTiming />
        <WhyChoose />
        <WhoFor />
        <SampleReport />
        <HowItWorks />
        <WhatPowers />
        <WhatsIncluded />
        <Pricing />
        <Testimonials />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
}
